import { all } from 'redux-saga/effects';
import { watcher as questionnaire } from '@store/sagas/questionnaire/watcher';

export default function* root() {
  yield all([questionnaire()]);
}
